import React, {useContext} from "react";
import SectionCard from "../common/SectionCard";
import DetailGrid from "../common/DetailGrid";
import {BankOutlined, EditOutlined} from "@ant-design/icons";
import {useLocation, useNavigate} from "react-router-dom";
import {Button} from "antd";
import UserLoginContext from "../../../../context/userLoginContext";
import CopyContent from "../../../../common/copy-content";

const BankDetailsTab = ({employeeData}: any) => {
    const navigate = useNavigate();
    const location = useLocation();
    const {user} = useContext(UserLoginContext);
    const isActiveEmployee = location.state?.isActive ?? true;
    const navigateToBankDetail = () => navigate(`/employee/edit/banking`, {state: {empId: employeeData.id}});
    const bank = employeeData?.bankDetail;
    return (
        <SectionCard
            icon={<BankOutlined style={{backgroundColor: "#dcfce7", color: "#15803d"}}/>}
            title="Bank Details"
            extra={
                user?.isAdmin && isActiveEmployee && (
                    <Button type={"link"} onClick={() => navigateToBankDetail()}> <EditOutlined/> </Button>
                )
            }
        >
            <DetailGrid
                data={[
                    {label: "Account Holder Name", value: <CopyContent content={bank?.accountHolderName}>
                            {bank?.accountHolderName}
                        </CopyContent>},
                    {label: "Account Number", value: <CopyContent content={bank?.accountNumber}>
                            {bank?.accountNumber}
                        </CopyContent>},
                    {label: "Branch Name", value: bank?.branchName},
                    {label: "Branch Code", value: bank?.branchCode},
                    {label: "IFSC Code", value: bank?.ifscCode},
                ]}
            />
        </SectionCard>
    );
};

export default BankDetailsTab;
